import React from "react";

import Divider from "@material-ui/core/Divider";

const InfoDivider = () => (
  <Divider classes={{ root: "divider" }} color="orange" />
);

export default InfoDivider;
